const routes = [
    {
        path: "/finance/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
